export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="text-lg font-heading text-background-50 mb-3">黑料吃瓜网</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              国内领先的娱乐爆料资讯聚合平台。聚焦娱乐圈一区二区最新动态，提供真实、快速、全面的吃瓜内容。24小时更新，高清在线播放，免下载即点即看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">内容分区</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">娱乐圈一区</a></li>
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">网红圈二区</a></li>
              <li><a href="#carousel" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">焦点专题</a></li>
              <li><a href="#media" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">视频专区</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快捷入口</h4>
            <ul className="space-y-2">
              <li><a href="#updates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">最新快讯</a></li>
              <li><a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热度榜单</a></li>
              <li><a href="#faq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">常见问答</a></li>
              <li><a href="#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">投稿联系</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/50 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; 2026 黑料吃瓜网 - 黑料吃瓜网曝一区二区 黑料吃瓜网在线观看 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">回到顶部</a>
            <a href="#faq" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">帮助中心</a>
            <a href="#about" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}